import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useForm } from 'react-hook-form';

const SuperAdminLogin = () => {
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = (data) => {
    setIsLoading(true);

    const payload = {
      Email: data.email,
      Password: data.password,
      RoleID: "3", // SuperAdmin Role ID
    };

    axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/login`, payload)
      .then(response => {
        setIsLoading(false);
        if (response.data.message === 'success') {
          navigate("/listofusers");
          localStorage.setItem("guid", response.data.Guid);
          localStorage.setItem("UserID", response.data.UserID);
          localStorage.setItem("RoleID", "3");
        } else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: response.data.message,
            showConfirmButton: false,
            timer: 3000
          });
        }
      })
      .catch(error => {
        setIsLoading(false);
        console.error('Error logging in:', error);
      });
  };

  return (
    <section className="vh-100">
      {isLoading ? <div className="spinner"></div> :
        <div className="container h-custom">
          <div className="row d-flex justify-content-center align-items-center mt-4">
            <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
              <img
                src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.webp"
                className="img-fluid"
                alt="Sample"
              />
            </div>
            <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
              <div className="card shadow-lg p-5" style={{ border: 'none' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <label className="form-label text-center">SuperAdmin Login</label>
                  <div className="form-outline mb-4">
                    <label className="form-label">Email address</label>
                    <input
                      type="email"
                      className={`form-control form-control-lg ${errors.email ? 'is-invalid' : ''}`}
                      placeholder="Enter a valid email address"
                      {...register('email', { required: 'Email is required' })}
                    />
                    {errors.email && <div className="invalid-feedback">{errors.email.message}</div>}
                  </div>

                  <div className="form-outline mb-3">
                    <label className="form-label">Password</label>
                    <input
                      type="password"
                      className={`form-control form-control-lg ${errors.password ? 'is-invalid' : ''}`}
                      placeholder="Enter password"
                      {...register('password', { required: 'Password is required' })}
                    />
                    {errors.password && <div className="invalid-feedback">{errors.password.message}</div>}
                  </div>

                  <div className="text-center d-flex justify-content-between mt-4">
                    <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                      Login
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      }
    </section>
  );
};

export default SuperAdminLogin;
